module.exports = __webpack_public_path__ + "media/images/untuckit-7a30b52727640b9ef9be74e573874979.png";